export const PURCHASE_TYPES = {
  MINI_COURSE: "mini_course",
  PERSONALIZED_PLAN: "personalized_plan",
  THREE_DAY_CHALLENGE: "three_day_challenge",
  MONTHLY_MEMBERSHIP: "monthly_membership",
  YEARLY_MEMBERSHIP: "yearly_membership",
  WEEKLY_SUBSCRIPTION: "weekly_subscription",
  MONTHLY_SUBSCRIPTION: "monthly_subscription",
  QUARTERLY_SUBSCRIPTION: "quarterly_subscription",
};

const PURCHASE_ALIASES = {
  "3_day_challenge": PURCHASE_TYPES.THREE_DAY_CHALLENGE,
  three_day_challenge: PURCHASE_TYPES.THREE_DAY_CHALLENGE,
  weekly: PURCHASE_TYPES.WEEKLY_SUBSCRIPTION,
  weekly_subscription: PURCHASE_TYPES.WEEKLY_SUBSCRIPTION,
  monthly: PURCHASE_TYPES.MONTHLY_SUBSCRIPTION,
  monthly_subscription: PURCHASE_TYPES.MONTHLY_SUBSCRIPTION,
  every_3_months: PURCHASE_TYPES.QUARTERLY_SUBSCRIPTION,
  quarterly_subscription: PURCHASE_TYPES.QUARTERLY_SUBSCRIPTION,
  monthly_membership: PURCHASE_TYPES.MONTHLY_MEMBERSHIP,
  yearly_membership: PURCHASE_TYPES.YEARLY_MEMBERSHIP,
  mini_course: PURCHASE_TYPES.MINI_COURSE,
  personalized_plan: PURCHASE_TYPES.PERSONALIZED_PLAN,
};

export const normalizePurchaseType = (purchaseType) => {
  if (!purchaseType || typeof purchaseType !== "string") return purchaseType;
  return PURCHASE_ALIASES[purchaseType] || purchaseType;
};

export const SUBSCRIPTION_PURCHASES = new Set([
  PURCHASE_TYPES.MONTHLY_MEMBERSHIP,
  PURCHASE_TYPES.YEARLY_MEMBERSHIP,
  PURCHASE_TYPES.WEEKLY_SUBSCRIPTION,
  PURCHASE_TYPES.MONTHLY_SUBSCRIPTION,
  PURCHASE_TYPES.QUARTERLY_SUBSCRIPTION,
]);

export const VIP_PURCHASES = new Set([
  PURCHASE_TYPES.YEARLY_MEMBERSHIP,
]);

export const hasActiveSubscription = (userData = {}, purchaseIds = []) => {
  if (userData.isSubscribed) return true;
  return purchaseIds.map(normalizePurchaseType).some((purchaseId) => SUBSCRIPTION_PURCHASES.has(purchaseId));
};

export const hasVIPAccess = (userData = {}, purchaseIds = []) => {
  const plan = normalizePurchaseType(userData.subscriptionPlan || userData.plan);
  if (plan && VIP_PURCHASES.has(plan)) return true;
  return purchaseIds.map(normalizePurchaseType).some((purchaseId) => VIP_PURCHASES.has(purchaseId));
};
